import "./ItemQubesLoaderStyles.css";
export default function ItemQubesLoader() {
  return (
    <div className="loop cubes">
      <div className="item cubes"></div>
      <div className="item cubes"></div>
      <div className="item cubes"></div>
      <div className="item cubes"></div>
      <div className="item cubes"></div>
      <div className="item cubes"></div>
    </div>
  );
}
